<template>
    <div>
        <topback title="Notification message" path="back"></topback>
        <md-tab-bar class="nav-tab" v-model="current" :items="items" @change="onTabChange"></md-tab-bar>
        <div class="deposit-history">
            <md-swiper ref="swiper" :autoplay="0" :is-prevent="false" :is-loop="false" :has-dots="false"
                @before-change="onSwiperChange">
                <md-swiper-item>
                    <div style="margin-top: 1rem;" v-if="unreadlist.length < 1">
                        <md-result-page img-url="/static/icon/noassets.png" text="Unread messages are empty" subtext="">
                        </md-result-page>
                    </div>
                    <div style="margin-top: 1rem;" v-else>
                        <md-cell-item v-for="u in unreadlist" v-bind:key="u.id" :brief="u.timestamp" :title="u.verb"
                            @click="shownotice(u)">
                            <template slot="right">
                                {{ u.level }}
                            </template>
                        </md-cell-item>
                        <md-button type="primary" class="mt-3" @click="all_messages_read">All messages read</md-button>
                    </div>
                </md-swiper-item>
                <md-swiper-item>
                    <div style="margin-top: 1rem;" v-if="allmessagelist.length < 1">
                        <md-result-page img-url="/static/icon/noassets.png" text="Messages is empty" subtext="">
                        </md-result-page>
                    </div>
                    <div style="margin-top: 1rem;" v-else>
                        <md-cell-item v-for="u in allmessagelist" v-bind:key="u.id" :brief="u.timestamp" :title="u.verb"
                            @click="shownotice(u)">
                            <template slot="right">
                                {{ u.level }}
                            </template>
                        </md-cell-item>
                    </div>
                </md-swiper-item>
            </md-swiper>
        </div>
    </div>
</template>

<script>
import topback from '@/components/topback'
import { alllist, unreadlist, messageasread, allmessageasread } from '@/request/api'
import { Dialog } from 'mand-mobile'
export default {
    name: 'deposithistory',
    components: {
        [topback.name]: topback,
    },

    data() {
        return {
            id: 0,
            current: 0,
            items: [{ name: 0, label: 'Unread' }, { name: 1, label: 'All message' }],
            unreadlist: [],
            allmessagelist: [],
        }
    },
    created() {
        this.getalllist();
        this.getunreadlist();
        this.id = this.$route.params.id;
        console.log(this.id);
    },
    methods: {
        all_messages_read()
        {
            this.$toast.loading("Loading...")
            allmessageasread().then(res => {
                this.getalllist();
                this.unreadlist = [];
                this.$toast.hide();
            })
        },
        shownotice(item) {
            let that = this;
            Dialog.alert({
                title: item.verb,
                content: item.description,
                confirmText: 'Confirm',
                onConfirm: () => {
                    messageasread(item.slug).then(res => {
                        for (let index = 0; index < this.unreadlist.length; index++) {
                            const element = this.unreadlist[index];
                            if (element.id == item.id) {
                                this.unreadlist.splice(index, 1);
                                break;
                            }
                        }
                    })
                },
            })
        },
        onSwiperChange(from, to) {
            this.current = to;
        },
        onTabChange(item, index) {
            this.$refs.swiper.goto(index)
        },
        getalllist() {
            let that = this;
            alllist().then(res => {
                that.allmessagelist = res.all_list;
                if (that.id && that.id > 0) {
                    console.log(that.id, that.allmessagelist);
                    for (let index = 0; index < that.allmessagelist.length; index++) {
                        const element = that.allmessagelist[index];
                        if (element.id == that.id) {
                            that.shownotice(element);
                            break;
                        }
                    }
                }
            })
        },
        getunreadlist() {
            let that = this;
            unreadlist().then(res => {
                that.unreadlist = res.unread_list;

            });
        },

    }
}

</script>
<style scoped>
.nav-tab {
    position: fixed !important;
    padding-left: 0.4rem;
    padding-right: 0.4rem;
    background-color: #f9fafb;
    top: 1rem;
    z-index: 998;
    width: 100%;
}

.deposit-history {
    margin-top: 1rem;
}


.deposit-history .md-swiper .md-swiper-item {
    padding: 20px;
    box-sizing: border-box;
    font-size: 24px;
    line-height: 1.5;
    color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/my/message.vue